/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthTrackerRouteImport } from './routes/_auth.tracker'
import { Route as AuthStrategyRouteImport } from './routes/_auth.strategy'
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings'
import { Route as AuthRisksRouteImport } from './routes/_auth.risks'
import { Route as AuthPlDiscoveryRouteImport } from './routes/_auth.pl-discovery'
import { Route as AuthLeadsRouteImport } from './routes/_auth.leads'
import { Route as AuthBillingRouteImport } from './routes/_auth.billing'
import { Route as AuthAnalyticsRouteImport } from './routes/_auth.analytics'
import { Route as AuthAdminsRouteImport } from './routes/_auth.admins'
import { Route as AuthAdminsAuditRouteImport } from './routes/_auth.admins.audit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTrackerRoute = AuthTrackerRouteImport.update({
  id: '/tracker',
  path: '/tracker',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth.tracker.lazy').then((d) => d.Route))
const AuthStrategyRoute = AuthStrategyRouteImport.update({
  id: '/strategy',
  path: '/strategy',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth.strategy.lazy').then((d) => d.Route),
)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth.settings.lazy').then((d) => d.Route),
)
const AuthRisksRoute = AuthRisksRouteImport.update({
  id: '/risks',
  path: '/risks',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth.risks.lazy').then((d) => d.Route))
const AuthPlDiscoveryRoute = AuthPlDiscoveryRouteImport.update({
  id: '/pl-discovery',
  path: '/pl-discovery',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth.pl-discovery.lazy').then((d) => d.Route),
)
const AuthLeadsRoute = AuthLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth.leads.lazy').then((d) => d.Route))
const AuthBillingRoute = AuthBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth.billing.lazy').then((d) => d.Route))
const AuthAnalyticsRoute = AuthAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth.analytics.lazy').then((d) => d.Route),
)
const AuthAdminsRoute = AuthAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth.admins.lazy').then((d) => d.Route))
const AuthAdminsAuditRoute = AuthAdminsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthAdminsRoute,
} as any).lazy(() =>
  import('./routes/_auth.admins.audit.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admins': typeof AuthAdminsRouteWithChildren
  '/analytics': typeof AuthAnalyticsRoute
  '/billing': typeof AuthBillingRoute
  '/leads': typeof AuthLeadsRoute
  '/pl-discovery': typeof AuthPlDiscoveryRoute
  '/risks': typeof AuthRisksRoute
  '/settings': typeof AuthSettingsRoute
  '/strategy': typeof AuthStrategyRoute
  '/tracker': typeof AuthTrackerRoute
  '/admins/audit': typeof AuthAdminsAuditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admins': typeof AuthAdminsRouteWithChildren
  '/analytics': typeof AuthAnalyticsRoute
  '/billing': typeof AuthBillingRoute
  '/leads': typeof AuthLeadsRoute
  '/pl-discovery': typeof AuthPlDiscoveryRoute
  '/risks': typeof AuthRisksRoute
  '/settings': typeof AuthSettingsRoute
  '/strategy': typeof AuthStrategyRoute
  '/tracker': typeof AuthTrackerRoute
  '/admins/audit': typeof AuthAdminsAuditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/admins': typeof AuthAdminsRouteWithChildren
  '/_auth/analytics': typeof AuthAnalyticsRoute
  '/_auth/billing': typeof AuthBillingRoute
  '/_auth/leads': typeof AuthLeadsRoute
  '/_auth/pl-discovery': typeof AuthPlDiscoveryRoute
  '/_auth/risks': typeof AuthRisksRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/strategy': typeof AuthStrategyRoute
  '/_auth/tracker': typeof AuthTrackerRoute
  '/_auth/admins/audit': typeof AuthAdminsAuditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admins'
    | '/analytics'
    | '/billing'
    | '/leads'
    | '/pl-discovery'
    | '/risks'
    | '/settings'
    | '/strategy'
    | '/tracker'
    | '/admins/audit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admins'
    | '/analytics'
    | '/billing'
    | '/leads'
    | '/pl-discovery'
    | '/risks'
    | '/settings'
    | '/strategy'
    | '/tracker'
    | '/admins/audit'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/admins'
    | '/_auth/analytics'
    | '/_auth/billing'
    | '/_auth/leads'
    | '/_auth/pl-discovery'
    | '/_auth/risks'
    | '/_auth/settings'
    | '/_auth/strategy'
    | '/_auth/tracker'
    | '/_auth/admins/audit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/tracker': {
      id: '/_auth/tracker'
      path: '/tracker'
      fullPath: '/tracker'
      preLoaderRoute: typeof AuthTrackerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/strategy': {
      id: '/_auth/strategy'
      path: '/strategy'
      fullPath: '/strategy'
      preLoaderRoute: typeof AuthStrategyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/risks': {
      id: '/_auth/risks'
      path: '/risks'
      fullPath: '/risks'
      preLoaderRoute: typeof AuthRisksRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pl-discovery': {
      id: '/_auth/pl-discovery'
      path: '/pl-discovery'
      fullPath: '/pl-discovery'
      preLoaderRoute: typeof AuthPlDiscoveryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/leads': {
      id: '/_auth/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AuthLeadsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing': {
      id: '/_auth/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/analytics': {
      id: '/_auth/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthAnalyticsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admins': {
      id: '/_auth/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AuthAdminsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admins/audit': {
      id: '/_auth/admins/audit'
      path: '/audit'
      fullPath: '/admins/audit'
      preLoaderRoute: typeof AuthAdminsAuditRouteImport
      parentRoute: typeof AuthAdminsRoute
    }
  }
}

interface AuthAdminsRouteChildren {
  AuthAdminsAuditRoute: typeof AuthAdminsAuditRoute
}

const AuthAdminsRouteChildren: AuthAdminsRouteChildren = {
  AuthAdminsAuditRoute: AuthAdminsAuditRoute,
}

const AuthAdminsRouteWithChildren = AuthAdminsRoute._addFileChildren(
  AuthAdminsRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminsRoute: typeof AuthAdminsRouteWithChildren
  AuthAnalyticsRoute: typeof AuthAnalyticsRoute
  AuthBillingRoute: typeof AuthBillingRoute
  AuthLeadsRoute: typeof AuthLeadsRoute
  AuthPlDiscoveryRoute: typeof AuthPlDiscoveryRoute
  AuthRisksRoute: typeof AuthRisksRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthStrategyRoute: typeof AuthStrategyRoute
  AuthTrackerRoute: typeof AuthTrackerRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminsRoute: AuthAdminsRouteWithChildren,
  AuthAnalyticsRoute: AuthAnalyticsRoute,
  AuthBillingRoute: AuthBillingRoute,
  AuthLeadsRoute: AuthLeadsRoute,
  AuthPlDiscoveryRoute: AuthPlDiscoveryRoute,
  AuthRisksRoute: AuthRisksRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthStrategyRoute: AuthStrategyRoute,
  AuthTrackerRoute: AuthTrackerRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
